/**
 * Google Ads コンバージョン計測ユーティリティ
 * LINEボタンクリック時にgtag eventを送信してからURLに遷移する
 */
export function gtagLineEvent(url: string, eventName: string): void {
  const navigate = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const gtagFn = (window as any).gtag;
  if (typeof gtagFn === 'function') {
    gtagFn('event', eventName, {
      event_callback: navigate,
      event_timeout: 2000,
    });
  } else {
    navigate();
  }
}
